import { connect } from 'react-redux';
import Error from './error';

const mapStateToProps = ({ application: { dynamicConfig } }) => ({ url: dynamicConfig?.url });

export default connect(mapStateToProps)(Error);
